export default __webpack_public_path__ + "img/448a1cbd64a49fd80a0bb60e5578e6ed.svg";